import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox']

  connect() {
    this.successClass = 'text-green-500'
    this.checkedName = 'checkmark-circle'
    this.uncheckedName = 'ellipse-outline'
  }

  get toggleUrl() {
    return this.data.get('url')
  }

  get accepted() {
    return this.checkboxTarget.classList.contains(this.successClass)
  }

  set accepted(value) {
    if (value) {
      this.checkboxTarget.name = this.checkedName
    } else {
      this.checkboxTarget.name = this.uncheckedName
    }
    this.checkboxTarget.classList.toggle(this.successClass, value)
  }

  /* eslint-disable no-underscore-dangle -- TODO: specs, convert these to private methods, & remove disable */
  accept() {
    this.accepted = true
    return this._setAcceptanceViaAPI()
      .catch(_err => {
        this.accepted = false
      })
  }

  toggleAccepted(e) {
    this.accepted = !this.accepted
    this._setAcceptanceViaAPI()
      .catch(_err => {
        this.accepted = !this.accepted
      })
      .then(_resp => {
        let event = new CustomEvent('item-accepted', { bubbles: true })
        e.target.dispatchEvent(event)
      })
  }

  _setAcceptanceViaAPI() {
    let data = new FormData()
    data.append('ticket_item[queue_accepted]', this.accepted)

    return fetch(this.toggleUrl, {
      method: 'PATCH',
      body: data
    }).then(this._throwIfError)
  }

  _throwIfError(response) {
    if (!response.ok) throw Error(response.statusText)
    return response
  }
  /* eslint-enable no-underscore-dangle */
}
